import './index.scss';
import { produce } from 'immer';
import React from 'react';
import MultiSelectInput from '~/components/input/multi_select';
import BoolInput from './bool_input';
import DateInput from './date_input';
import SelectInput from './select_input';
import TextInput from './text_input';
const SEARCHABLE_MULTI_SELECT_INPUTS = ['Jurisdiction'];
const MetadataInput = (props) => {
    var _a, _b, _c;
    const { orgMetadataField, onChange, metadata, required, isOptional, hasRequiredError, } = props;
    const { type, isRequired } = orgMetadataField;
    const isActuallyRequired = () => {
        return !isOptional && (required || isRequired);
    };
    const val = (_a = metadata.find(metadataField => metadataField.name === orgMetadataField.name)) === null || _a === void 0 ? void 0 : _a.value;
    if (type === 'text') {
        if (!((_b = orgMetadataField.options) === null || _b === void 0 ? void 0 : _b.length) && ((_c = orgMetadataField.options) === null || _c === void 0 ? void 0 : _c.length) !== 0) {
            return (React.createElement(TextInput, { orgMetadataField: orgMetadataField, onChange: onChange, isRequired: isActuallyRequired(), hasRequiredError: hasRequiredError, val: val === undefined || typeof val === 'string' ? val : undefined }));
        }
        if (!orgMetadataField.isMulti) {
            return (React.createElement(SelectInput, { orgMetadataField: orgMetadataField, onChange: onChange, isRequired: isActuallyRequired(), hasRequiredError: hasRequiredError, val: val === undefined || typeof val === 'string' ? val : undefined }));
        }
        let { subField, options } = orgMetadataField;
        if (Array.isArray(options) && options.length) {
            options = [...options];
            options.sort((a, b) => {
                return a.optionName.toUpperCase() > b.optionName.toUpperCase() ? 1 : -1;
            });
        }
        if (subField && !subField.options) {
            subField = produce(subField, (draft) => {
                const subOptions = draft.isMulti && options && Array.isArray(val)
                    ? options.filter(opt => val.includes(opt.optionName)).reduce((prev, opt) => {
                        return [...prev, ...opt.subOptions || []];
                    }, [])
                    : [];
                draft.options = subOptions;
            });
        }
        return (React.createElement("div", { className: 'form-input-group' },
            React.createElement("label", { className: 'input-label', htmlFor: orgMetadataField.name },
                orgMetadataField.name,
                " ",
                isActuallyRequired() ? '*' : ''),
            React.createElement(MultiSelectInput, { hasSearchFilter: SEARCHABLE_MULTI_SELECT_INPUTS.includes(orgMetadataField.name), name: orgMetadataField.name, onChange: onChange, options: options, renderSubOptions: false, selectedOptions: val }),
            isRequired && hasRequiredError &&
                React.createElement("span", { className: 'required-error' }, "Required"),
            subField &&
                React.createElement(MetadataInput, { orgMetadataField: subField, onChange: onChange, metadata: metadata, required: false, isOptional: true, hasRequiredError: false })));
    }
    if (type === 'date') {
        return (React.createElement(DateInput, { orgMetadataField: orgMetadataField, onChange: onChange, isRequired: isActuallyRequired(), hasRequiredError: hasRequiredError, val: val === undefined || typeof val === 'string' ? val : undefined }));
    }
    if (type === 'bool') {
        return (React.createElement(BoolInput, { orgMetadataField: orgMetadataField, onChange: onChange, isRequired: isActuallyRequired(), hasRequiredError: hasRequiredError, val: val === undefined || typeof val === 'boolean' ? val : undefined }));
    }
    return React.createElement(React.Fragment, null);
};
export default MetadataInput;
